import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import api from '@survey/common/dist/middleware/api';
import addressValidationApi from '../middleware/addressValidationApi';
import rootReducer from '../index.reducer';

const configureStore = preloadedState => createStore(rootReducer, preloadedState, applyMiddleware(thunk, api, addressValidationApi));

export default configureStore;
